/**
 * Note: properties starting with a '_' are removed before sending
 *
 * @module app.model
 * @license Copyright 2013 (c) RISE Ges.m.b.H.
 *  ____   ___  ____   _____
 * |  _ \  | | / ___| | ____|
 * | |_) | | | \___ \ |  _|
 * |  _ <  | |  ___) || |___
 * |_| \_\ |_| |____/ |_____|
 *
 */
(function(app) {
    "use strict";

    // Models _need_ to be a function with a name (NOT an anonymous function!)
    app.model.Employee = function Employee(json) {
        var obj = (typeof json === 'string') ? JSON.parse(json) : json;

        if (!obj) {
            obj = {};
        }

        this.id =  obj.id != null ? parseInt(obj.id) : null;

        this.workplaces =  listOfModels(obj.workplaces, app.model.Workplace);

        this.number = obj.number != null ? obj.number : null;

        this.synchronized_at =  obj.synchronized_at ?
            typeof obj.synchronized_at === 'string' ?
                Date.fromISO(obj.synchronized_at)
                : obj.synchronized_at
            : null;

        app.model.User.apply(this, [obj]);
    };

    function listOfModels(prop, Model) {
        if (prop == null) {
            return [];
        }

        return _.map(prop, function(entity) {
            return new Model(entity);
        });
    }

}(window.app));
